<template>
	<div>
		<div class="container">
			<el-form :label-width="'30%'" :model="step2Form" :rules="rules" ref="step2Form">
				<h4 >Personal Infomation</h4>
				<el-row :gutter="0">
					<el-col :span="18">
						<el-form-item label="Title" prop="title" class="step-form__form-item--with-unit">
							<el-select v-model="step2Form.title" placeholder="Please select title" :disabled="isEditable === 1">
								<el-option v-for="item in titleData" :key="item.value" :label="item.text" :value="item.text">
								</el-option>
							</el-select>
						</el-form-item>

						<!--First Name-->
						<el-form-item label="First Name" prop="firstName">
							<el-input type="text" placeholder="First Name" :maxlength="30" v-model="step2Form.firstName"></el-input>
						</el-form-item>

						<el-form-item label="Middle Name">
							<el-input type="text" placeholder="Middle Name" :maxlength="30" v-model="step2Form.middleName"></el-input>
						</el-form-item>

						<el-form-item label="Last Name" prop="lastName">
							<el-input type="text" placeholder="Last Name" :maxlength="30" v-model="step2Form.lastName"></el-input>
						</el-form-item>

						<!-- <el-form-item label="Date of Birth" prop="dateOfBirth">
							<el-date-picker v-model="step2Form.dateOfBirth" type="date" placeholder="Please select date of birth" @change="getData"
							 :picker-options="pickerOptions1">
							</el-date-picker>
						</el-form-item> -->
						<el-form-item label="Date of Birth" prop="dateOfBirthStr">
							<el-input type="text" placeholder="MM/DD/YYYY" :maxlength="10" v-model="step2Form.dateOfBirthStr"></el-input>
						</el-form-item>

						<el-form-item label="Marital Status" prop="status" class="step-form__form-item--with-unit">
							<el-select v-model="step2Form.status" placeholder="Please Select Marital status">
								<el-option v-for="item in mastateS" :key="item.value" :label="item.text" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="SSN" prop="ssn">
							<el-input type="text" placeholder="Please input your SSN." onkeypress="return event.keyCode>=48&&event.keyCode<=57"
							 v-model="step2Form.ssn" :maxlength="9">

							</el-input>
							We use 128-bit SSL protection and strict, high levels of security and encryption standards to keep
							your information safe.
						</el-form-item>

						<el-form-item label="Driver License" prop="driverLicense">
							<el-input type="text" placeholder="" :maxlength="20" v-model="step2Form.driverLicense"></el-input>
						</el-form-item>

						<el-form-item label="Street Address" prop="streetAddress">
							<el-input type="text" placeholder="" :maxlength="80" v-model="step2Form.streetAddress"></el-input>
						</el-form-item>

						<el-form-item label="Address Line 2" prop="streetAddressLine2">
							<el-input type="text" placeholder="" :maxlength="40" v-model="step2Form.streetAddressLine2"></el-input>
						</el-form-item>

						<el-form-item label="City Name" prop="cityName">
							<el-input type="text" placeholder="" :maxlength="30" v-model="step2Form.cityName"></el-input>
						</el-form-item>

						<el-form-item label="State" prop="state" class="step-form__form-item--with-unit">
							<el-select v-model="step2Form.state" placeholder="Please Select State">
								<el-option v-for="item in stateS" :key="item.value" :label="item.text" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="Zip Code" prop="zipCode">
							<el-input type="tel" onkeypress="return event.keyCode>=48&&event.keyCode<=57" placeholder="Please enter a 5-digit postal code"
							 :maxlength="5" v-model="step2Form.zipCode"></el-input>
						</el-form-item>
						<el-form-item label="Mobile Phone" prop="cellphone" ref="cellphone">
							<el-input type="tel" placeholder="Mobile Phone" onkeypress="return event.keyCode>=48&&event.keyCode<=57" v-model="step2Form.cellPhone" :maxlength="10"></el-input>
						</el-form-item>
						<el-form-item label="Home Phone" prop="homePhone" ref="homePhone">
							<el-input type="tel" placeholder="Home Phone" onkeypress="return event.keyCode>=48&&event.keyCode<=57" v-model="step2Form.homePhone" :maxlength="10"></el-input>
						</el-form-item>
						<el-form-item label="When did you start living at your current address?" prop="month">
							<el-date-picker v-model="step2Form.month" type="month" placeholder="Month, Year" format="MMM, yyyy" @change="getData3" :picker-options="pickerOptions1">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="Monthly housing payment" prop="housingCost">
							<el-input type="number" placeholder="What is your monthly housing payment? (Please input numbers only)" v-model="step2Form.housingCost" onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          :maxlength="8"
                          :min="0">
							</el-input>
							If you live with others, only include the portion of the monthly housing payment you are responsible for.
						</el-form-item>
						<el-form-item label="Home Ownership (select)">
						</el-form-item>
						<el-form-item label="" prop="homeOwnership">
							<el-radio-group v-model="step2Form.homeOwnership">
								<el-row :gutter="10">
								<el-radio label="Rent">Rent</el-radio>
								</el-row>
								<!-- <el-row :gutter="10">>
								<el-radio label="Mortgage">Mortgage</el-radio>
								</el-row> -->
								<el-row :gutter="10">
								<el-radio label="Own">Own</el-radio>
								</el-row>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="Business Ownership %" prop="businessOwnership">
							<el-input-number :min="0" :max="100" v-model="step2Form.businessOwnership"></el-input-number>
						</el-form-item>


					</el-col>
				</el-row>
				<h4 >Additional Principals/ Officers/ Guarantors (if any)</h4>
				<el-row :gutter="0">
					<el-col :span="18">
						<el-form-item label="Title" prop="title2" class="step-form__form-item--with-unit">
							<el-select v-model="step2Form.title2" placeholder="Please select title" :disabled="isEditable === 1">
								<el-option v-for="item in titleData" :key="item.value" :label="item.text" :value="item.text">
								</el-option>
							</el-select>
						</el-form-item>

						<!--First Name-->
						<el-form-item label="First Name" prop="firstName2">
							<el-input type="text" placeholder="First Name" :maxlength="30" v-model="step2Form.firstName2"></el-input>
						</el-form-item>

						<el-form-item label="Middle Name">
							<el-input type="text" placeholder="Middle Name" :maxlength="30" v-model="step2Form.middleName2"></el-input>
						</el-form-item>

						<el-form-item label="Last Name" prop="lastName2">
							<el-input type="text" placeholder="Last Name" :maxlength="30" v-model="step2Form.lastName2"></el-input>
						</el-form-item>

						<!-- <el-form-item label="Date of Birth" prop="dateOfBirth2">
							<el-date-picker v-model="step2Form.dateOfBirth2" type="date" placeholder="Please select date of birth" @change="getData2"
							 :picker-options="pickerOptions1">
							</el-date-picker>
						</el-form-item> -->

						<el-form-item label="Date of Birth" prop="dateOfBirthStr2">
							<el-input type="text" placeholder="MM/DD/YYYY" :maxlength="10" v-model="step2Form.dateOfBirthStr2"></el-input>
						</el-form-item>

						<el-form-item label="Marital Status" prop="status2" class="step-form__form-item--with-unit">
							<el-select v-model="step2Form.status2" placeholder="Please Select Marital status">
								<el-option v-for="item in mastateS" :key="item.value" :label="item.text" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="SSN" prop="ssn2">
							<el-input type="text" placeholder="Please input your SSN." onkeypress="return event.keyCode>=48&&event.keyCode<=57"
							 v-model="step2Form.ssn2" :maxlength="9">

							</el-input>
							We use 128-bit SSL protection and strict, high levels of security and encryption standards to keep
							your information safe.
						</el-form-item>

						<el-form-item label="Driver License" prop="driverLicense2">
							<el-input type="text" placeholder="" :maxlength="20" v-model="step2Form.driverLicense2"></el-input>
						</el-form-item>

						<el-form-item label="Street Address" prop="streetAddress2">
							<el-input type="text" placeholder="" :maxlength="80" v-model="step2Form.streetAddress2"></el-input>
						</el-form-item>

						<el-form-item label="Address Line 2" prop="streetAddress2Line2">
							<el-input type="tel" placeholder="" :maxlength="40" v-model="step2Form.streetAddress2Line2"></el-input>
						</el-form-item>

						<el-form-item label="City Name" prop="cityName2">
							<el-input type="text" placeholder="" :maxlength="30" v-model="step2Form.cityName2"></el-input>
						</el-form-item>

						<el-form-item label="State" prop="state2" class="step-form__form-item--with-unit">
							<el-select v-model="step2Form.state2" placeholder="Please Select State">
								<el-option v-for="item in stateS" :key="item.value" :label="item.text" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="Zip Code" prop="zipCode2">
							<el-input type="tel" onkeypress="return event.keyCode>=48&&event.keyCode<=57" placeholder="Please enter a 5-digit postal code"
							 :maxlength="5" v-model="step2Form.zipCode2"></el-input>
						</el-form-item>
						<el-form-item label="Mobile Phone" prop="cellphone2" ref="cellphone2">
							<el-input type="tel" placeholder="Mobile Phone" onkeypress="return event.keyCode>=48&&event.keyCode<=57" v-model="step2Form.cellPhone2" :maxlength="10"></el-input>
						</el-form-item>
						<el-form-item label="Home Phone" prop="homePhone2" ref="homePhone2">
							<el-input type="tel" placeholder="Home Phone" onkeypress="return event.keyCode>=48&&event.keyCode<=57" v-model="step2Form.homePhone2" :maxlength="10"></el-input>
						</el-form-item>
						<el-form-item label="When did you start living at your current address?" prop="month2">
							<el-date-picker v-model="step2Form.month2" type="month" placeholder="Month, Year" format="MMM, yyyy" @change="getData3" :picker-options="pickerOptions1">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="Monthly housing payment" prop="housingCost2">
							<el-input type="number" placeholder="What is your monthly housing payment? (Please input numbers only)" v-model="step2Form.housingCost2" onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          :maxlength="8"
                          :min="0">
							</el-input>
							If you live with others, only include the portion of the monthly housing payment you are responsible for.
						</el-form-item>
						<el-form-item label="Home Ownership (select)">
						</el-form-item>
						<el-form-item label="" prop="homeOwnership2">
							<el-radio-group v-model="step2Form.homeOwnership2">
								<el-row :gutter="10">
								<el-radio label="Rent">Rent</el-radio>
								</el-row>
								<!-- <el-row :gutter="10">>
								<el-radio label="Mortgage">Mortgage</el-radio>
								</el-row> -->
								<el-row :gutter="10">
								<el-radio label="Own">Own</el-radio>
								</el-row>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="Business Ownership %" prop="businessOwnership2">
							<el-input-number :min="0" :max="100" v-model="step2Form.businessOwnership2"></el-input-number>
						</el-form-item>


					</el-col>
				</el-row>
			</el-form>

			<div class="text-center">
				<el-button type="primary" :loading="isLoading" class="personal-center-form__submit" @click="submitForm">
					submit
				</el-button>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		mapGetters,
		mapActions
	} from 'vuex'
	import * as types from '../../vuex/types'
	import _ from 'lodash'
	import api from '../../vuex/api/index'

	// ä¼�ä¸šé‚£è¾¹å¦‚æžœç•Œé�¢å·®å¼‚å�˜å¤§ï¼Œåˆ™å»ºè®®åˆ†å‡ºåŽ»å�¦ä¸€ä¸ªç»„ä»¶
	export default {
		data() {
			const assignValidator = (type, trigger = 'blur') => Object.assign({
				//        required: true,
				trigger
			}, {
				validator: (rules, value, callback, source, options) => {
					this.$store.dispatch(type, {
						rules,
						value,
						callback,
						source,
						options
					})
				}
			})
			return {
				pickerOptions1: {
					disabledDate(time) {
					  let curDate = (new Date()).getTime();
						let I8Years = 365 * 18 * 24 * 3600 * 1000;
						let I00Years = 365 * 100 * 24 * 3600 * 1000;
						let I8YearsDate = curDate - I8Years;
						let I00YearsDate = curDate - I00Years;
            // return time.getTime() > I8YearsDate || time.getTime() < I00YearsDate;
          	return time.getTime() < I00YearsDate;
					}
				},
				dateOfBirthDis: false,
				isLoading: false,
				isLoadingCode: false,
				isSubmitting: false,
				isEditable: '',
				screenHeight: document.body.clientHeight,
				isAllowSendingVerifyCode: true,
				SMSVerificationCode: '',
				isApplyFirst: true,
				SMSVerificationCodeBtn: {
					disabled: true,
					text: 'get email verification code'
				},
				rules: {
					// title: [{
					// 	require: true,
					// 	trigger: 'blur',
					// 	validator: (rules, value, callback) => {
					// 		if (_.trim(value) === '') {
					// 			callback(new Error('Select a title for you.'))
					// 		} else {
					// 			callback()
					// 		}
					// 	}
					// }],
					firstName: [{
						require: true,
						trigger: 'blur',
						validator: (rules, value, callback) => {
							if (_.trim(value) === '') {
								callback(new Error('Enter a first name.'))
							} else {
								callback()
							}
						}
					}],

					middleName: [{
						require: true,
						trigger: 'blur',
						validator: (rules, value, callback) => {
							if (_.trim(value) === '') {
								callback(new Error('Enter a middle name.'))
							} else {
								callback()
							}
						}
					}],
					lastName: [{
						require: true,
						trigger: 'blur',
						validator: (rules, value, callback) => {
							if (_.trim(value) === '') {
								callback(new Error('Enter a Last name.'))
							} else {
								callback()
							}
						}
					}],
					validCode: [{
						require: true,
						trigger: 'blur',
						validator: (rules, value, callback) => {
							if (_.trim(value) === '') {
								callback(new Error('Please enter a valid code.'))
							} else {
								callback()
							}
						}
					}],
					streetAddress: [{
						require: true,
						trigger: 'blur',
						validator: (rules, value, callback) => {
							if (_.trim(value) === '') {
								callback(new Error('Street Address1 can not be empty'))
							} else {
								callback()
							}
						}
					}],

					cityName: [{
						require: true,
						trigger: 'blur',
						validator: (rules, value, callback) => {
							if (_.trim(value) === '') {
								callback(new Error('City Name can not be empty'))
							} else {
								callback()
							}
						}
					}],
					city: [{
						require: true,
						trigger: 'blur',
						validator: (rules, value, callback) => {
							if (_.trim(value) === '') {
								callback(new Error('City can not be empty'))
							} else {
								callback()
							}
						}
					}],
					personDocumentType: [{
						require: true,
						trigger: 'blur',
						validator: (rules, value, callback) => {
							if (_.trim(value) === '') {
								callback(new Error('PersonDocumentType can not be empty'))
							} else {
								callback()
							}
						}
					}],
					zipCode: [{
						require: true,
						trigger: 'blur',
						validator: (rules, value, callback) => {
							if (_.trim(value) === '') {
								callback(new Error('Zip code can not be empty'))
							} else if (!/^[0-9]*$/.test(value)) {
								callback(new Error('Input error'))
							} else {
								callback()
							}
						}
					}],
					state: [{
						require: true,
						trigger: 'blur',
						validator: (rules, value, callback) => {
							if (_.trim(value) === '') {
								callback(new Error('State can not be empty'))
							} else {
								callback()
							}
						}
					}],
					// dateOfBirthStr: [{
					// 	require: true,
					// 	trigger: 'blur',
					// 	validator: (rules, value, callback) => {
					// 		if (_.trim(value) === '') {
					// 			callback(new Error('Date of Birth can not be empty'))
					// 		} else {
					// 			callback()
					// 		}
					// 	}
					// }],
					// status: [{
					// 	require: true,
					// 	trigger: 'blur',
					// 	validator: (rules, value, callback) => {
					// 		if (_.trim(value) === '') {
					// 			callback(new Error('Marital Status can not be empty'))
					// 		} else {
					// 			callback()
					// 		}
					// 	}
					// }],


					ssn: [{
						// require: true,
						trigger: 'blur',
						validator: (rule, value, callback) => {
							if (_.trim(value) === '') {
								// callback(new Error('SSN can not be empty'))
								callback();
							} else if (!/^[0-9]*$/.test(value)) {
								callback(new Error('Input error'))
							} else {
								callback()
							}
						}
					}],
					// driverLicense: [{
					// 	require: true,
					// 	trigger: 'blur',
					// 	validator: (rule, value, callback) => {
					// 		if (_.trim(value) === '') {
					// 			callback(new Error('Driver License can not be empty'))
					// 		} else {
					// 			callback()
					// 		}
					// 	}
					// }],
					// homeOwnership: [{
					// 	require: true,
					// 	trigger: 'blur',
					// 	validator: (rules, value, callback) => {
					// 		if (_.trim(value) === '') {
					// 			callback(new Error('Home Ownership can not be empty'))
					// 		} else {
					// 			callback()
					// 		}
					// 	}
					// }]
				},
				stateS: [],
				titleData: [],
				citizenshipS: [],
				mastateS: [],
				isEditable: 0,
				dateOfBirthStr: '',
				dateOfBirth2Str: '',
				step2Form: {
					firstName: '',
					middleName: '',
					lastName: '',
					email: '',
					cellPhone:'',
					homePhone: '',
					validCode: '',
					streetAddress: '',
					streetAddressLine2: '',
					cityName: '',
					title: '',
					city: '',
					personDocumentType: '',
					zipCode: '',
					state: '',
					ssn: '',
					dateOfBirthStr: '',
					homeOwnership: '',
					month: '',
					housingCost: '',
					status: '',
					businessOwnership: '',
					lastName2: '',
					middleName2: '',
					firstName2: '',
					email2: '',
					phone2: '',
					streetAddress2: '',
					streetAddress2Line2: '',
					cityName2: '',
					title2: '',
					state2: '',
					ssn2: '',
					driverLicense2: '',
					zipCode2: '',
					status2: '',
					dateOfBirthStr2: '',
					homeOwnership2: '',
					month2: '',
					housingCost2: '',
					businessOwnership2: ''
				}

			}
		},
		computed: {
			...mapGetters({
				//       myInfo: types.GET_MY_INFO,
				userInfo: types.GET_USER
			})
		},
		methods: {
			...mapActions({
				updatePassword: types.UPDATE_PASSWORD,
				//        getPersonalInfo: types.GET_PERSONAL_INFO,
				getEnterpriseInfo: types.GET_ENTERPRISE_INFO,
				savePersonalInfo: types.SAVE_PERSONAL_INFO,
				saveEnterpriseInfo: types.SAVE_ENTERPRISE_INFO,
				saveApplyLoanProgress: types.SAVE_APPLY_LOAN_PROGRESS,
				setSuccessMessage: types.SET_SUCCESS_MESSAGE,
				setAlertMessage: types.SET_FAIL_MESSAGE
			}),
			allowSendEmailCode() {
				if (this.step2Form.email != '') {
					this.SMSVerificationCodeBtn.disabled = false;
				} else {
					this.SMSVerificationCodeBtn.disabled = true;
				}
			},

			getData(val) {
				this.dateOfBirthStr = val
			},
			getData2(val) {
				this.dateOfBirth2Str = val
			},
			getData3(val) {
				console.log(val)
				console.log(new Date(val).toISOString())
				console.log('this.step2Form.month',this.step2Form.month)
				if(this.step2Form.month !== null && typeof this.step2Form.month === 'object') {
					console.log(this.step2Form.month.toISOString())
				}
				console.log('this.step2Form.month2',this.step2Form.month2)
				if(this.step2Form.month2 !== null && typeof this.step2Form.month2 === 'object') {
					console.log(this.step2Form.month2.toISOString())
				}
			},
			getAge(dateString) {
				var today = new Date();
				var birthDate = new Date(dateString);
				var age = today.getFullYear() - birthDate.getFullYear();
				var m = today.getMonth() - birthDate.getMonth();
				if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
					age--;
				}
				return age > 18;
			},
			getMgxyGetPersonDetails() { //èŽ·å�–è¿›ä»¶ä¸ªäººä¿¡æ�¯
				var _this = this;
				//console.warn(this.userInfo)
				api.mgxyGetPersonDetails({
					token: _this.userInfo.token,
					frontApply: localStorage.getItem('$applyId'),
					customerId: _this.userInfo.crmCustomerId,
				}).then((res) => {
					var _data = res.data;
					if (_data.code == 0) {
						console.log(_data);
						_this.step2Form.title = _data.result.title;
						_this.step2Form.firstName = _data.result.firstName;
						_this.step2Form.middleName = _data.result.middleName;
						_this.step2Form.lastName = _data.result.lastName;
						_this.step2Form.email = _data.result.email;
						_this.step2Form.cellPhone = _data.result.phone;
						_this.step2Form.homePhone = _data.result.homePhone;
						_this.step2Form.dateOfBirthStr = _data.result.dateOfBirthStr;
						// _this.step2Form.dateOfBirth = _data.result.dateOfBirth ? new Date(_data.result.dateOfBirth.replace(/-/g, "\/")) : "";
						// if (_data.result.dataOfBirth && _data.result.dataOfBirth != '') {
						// 	this.dateOfBirthDis = true;
						// }
						_this.step2Form.ssn = _data.result.ssn;
						_this.step2Form.streetAddress = _data.result.streetAddress;
						_this.step2Form.streetAddressLine2 = _data.result.streetAddressLine2;
						_this.step2Form.driverLicense = _data.result.driverLicense;
						_this.step2Form.housingCost = _data.result.housingCost;
						_this.step2Form.state = _data.result.state;
						_this.step2Form.status = _data.result.status;
						_this.step2Form.cityName = _data.result.cityName;
						_this.step2Form.zipCode = _data.result.zipCode;
						if(_data.result.month !== null && _data.result.month !== undefined && _data.result.month !== '') {
							_this.step2Form.month = new Date(_data.result.month);
						} 
						_this.step2Form.homeOwnership = _data.result.homeOwnership;
						_this.step2Form.businessOwnership = _data.result.businessOwnership;
						
						_this.step2Form.title2 = _data.result.title2;
						_this.step2Form.firstName2 = _data.result.firstName2;
						_this.step2Form.middleName2 = _data.result.middleName2;
						_this.step2Form.lastName2 = _data.result.lastName2;
						_this.step2Form.email2 = _data.result.email2;
						_this.step2Form.cellPhone2 = _data.result.phone2;
						_this.step2Form.homePhone2 = _data.result.homePhone2;
						_this.step2Form.dateOfBirthStr2 = _data.result.dateOfBirthStr2;
						// _this.step2Form.dateOfBirth2 = _data.result.dateOfBirth2 ? new Date(_data.result.dateOfBirth2.replace(/-/g, "\/")) : "";
						_this.step2Form.ssn2 = _data.result.ssn2;
						_this.step2Form.streetAddress2 = _data.result.streetAddress2;
						_this.step2Form.streetAddress2Line2 = _data.result.streetAddress2Line2;
						_this.step2Form.driverLicense2 = _data.result.driverLicense2;
						_this.step2Form.housingCost2 = _data.result.housingCost2;
						_this.step2Form.state2 = _data.result.state2;
						_this.step2Form.status2 = _data.result.status2;
						_this.step2Form.cityName2 = _data.result.cityName2;
						_this.step2Form.zipCode2 = _data.result.zipCode2;
						if(_data.result.month2 !== null && _data.result.month2 !== undefined && _data.result.month2 !== '') {
							_this.step2Form.month2 = new Date(_data.result.month2);
						} 
						_this.step2Form.homeOwnership2 = _data.result.homeOwnership2;
						_this.step2Form.businessOwnership2 = _data.result.businessOwnership2;
						console.log(_this.step2Form);
					}
				})
			},
			formatData(data) {
				var arr = [];
				for (var key in data) {
					var obj = {};
					obj.value = data[key];
					obj.text = key;
					arr.push(obj)
				}
				return arr;
			},
			formatDataForSort(data) {
				var arr = [];
				var arr2 = [];
				for (var key in data) {
					arr[arr.length] = data[key];
				}
				arr.sort();
				for (var k in arr) {
					for (key in data) {
						if (data[key] == arr[k]) {
							var obj = {};
							obj.value = data[key];
							obj.text = key;
							arr2.push(obj);
						}
					}
				}
				return arr2;
			},
			getMgxyDictionary() {
				var _this = this;
				api.mgxyDictionary().then((res) => {
					_this.stateS = _this.formatData(res.data.result[0]);
					_this.titleData = _this.formatData(res.data.result[7]);
					_this.citizenshipS = _this.formatDataForSort(res.data.result[8]);
					_this.mastateS = _this.formatData(res.data.result[6]);
					var mgxy_income_source = _this.formatData(res.data.result[2]);
					_this.getMgxyGetPersonDetails();

				})
			},
			goBack() {
				this.saveApplyLoanProgress({
					router: this.$router,
					token: this.userInfo.token,
					id: this.$route.query.applyLoanId,
					step: 1
				}).then((res) => {
					const resData = res.data
					if (Number(resData.code) === 0) {
						//            if (`${this.$route.query.isEdit}` === 'true') {
						this.$router.push({
							path: `/personalCenter/myLoan/loanLists`,
							query: {
								frontApplyState: 0,
								pageCount: 1
							}
						})
						//            } else {
						//              this.$router.go(-1)
						//            }
					}
				})
			},

			submitForm() {
				var _this = this;
				this.$refs.step2Form.validate((valid) => {
					if (valid) {
						if (!this.getAge(this.step2Form.dateOfBirthStr)) { //æœªå¹´æ»¡18å²�
							this.$alert('Age must be more than 18 years old');
							return;
						}
						this.isLoading = true;
						var isValid = '';
						if (_this.isApplyFirst) {
							//isValid=1 éœ€è¦�éªŒè¯�éªŒè¯�ç �ã€‚isValid=2ä¸�ç”¨éªŒè¯�
							isValid = 2
						} else {
							_this.SMSVerificationCode = '111111';
							isValid = 2
						}

						var Month = new Array();
						Month[0] = "January";
						Month[1] = "February";
						Month[2] = "March";
						Month[3] = "April";
						Month[4] = "May";
						Month[5] = "June";
						Month[6] = "July";
						Month[7] = "August";
						Month[8] = "September";
						Month[9] = "October";
						Month[10] = "November";
						Month[11] = "December";

						var postData = {
							tokenId: _this.userInfo.token,
							// frontApplyId: _this.userInfo.crmCustomerId,

							lastName: _this.step2Form.lastName,
							middleName: _this.step2Form.middleName || '',
							firstName: _this.step2Form.firstName,
							email: _this.step2Form.email,
							phone: _this.step2Form.cellPhone || '',
							validCode: _this.SMSVerificationCode,
							streetAddress: _this.step2Form.streetAddress,
							streetAddressLine2: _this.step2Form.streetAddressLine2 || '',
							cityName: _this.step2Form.cityName,
							title: _this.step2Form.title || '',
							state: _this.step2Form.state,
							ssn: _this.step2Form.ssn || '',
							driverLicense: _this.step2Form.driverLicense || '',
							zipCode: _this.step2Form.zipCode,
							status: _this.step2Form.status || '',
							dateOfBirthStr: _this.step2Form.dateOfBirthStr || '',
							isValid: isValid,
							homeOwnership: _this.step2Form.homeOwnership || '',

							lastName2: _this.step2Form.lastName2 || '',
							middleName2: _this.step2Form.middleName2 || '',
							firstName2: _this.step2Form.firstName2 || '',
							email2: _this.step2Form.email2 || '',
							phone2: _this.step2Form.cellPhone2 || '',
							streetAddress2: _this.step2Form.streetAddress2 || '',
							streetAddress2Line2: _this.step2Form.streetAddress2Line2 || '',
							cityName2: _this.step2Form.cityName2 || '',
							title2: _this.step2Form.title2 || '',
							state2: _this.step2Form.state2 || '',
							ssn2: _this.step2Form.ssn2 || '',
							driverLicense2: _this.step2Form.driverLicense2 || '',
							zipCode2: _this.step2Form.zipCode2 || '',
							status2: _this.step2Form.status2 || '',
							dateOfBirthStr2: _this.step2Form.dateOfBirthStr2 || '',
							homeOwnership2: _this.step2Form.homeOwnership2 || ''
						};

						if(_this.step2Form.housingCost !== null && _this.step2Form.housingCost !== undefined && _this.step2Form.housingCost !== '') {
							postData.housingCost = _this.step2Form.housingCost;
						}

						if(_this.step2Form.housingCost2 !== null && _this.step2Form.housingCost2 !== undefined && _this.step2Form.housingCost2 !== '') {
							postData.housingCost2 = _this.step2Form.housingCost2;
						}

						if(_this.step2Form.month !== null && _this.step2Form.month !== undefined && _this.step2Form.month !== '') {
							postData.month = _this.step2Form.month.toISOString();
						}

						if(_this.step2Form.month2 !== null && _this.step2Form.month2 !== undefined && _this.step2Form.month2 !== '') {
							postData.month2 = _this.step2Form.month2.toISOString();
						}

						if(_this.step2Form.businessOwnership !== null && _this.step2Form.businessOwnership !== undefined && _this.step2Form.businessOwnership !== '') {
							postData.businessOwnership = _this.step2Form.businessOwnership;
						}

						if(_this.step2Form.businessOwnership2 !== null && _this.step2Form.businessOwnership2 !== undefined && _this.step2Form.businessOwnership2 !== '') {
							postData.businessOwnership2 = _this.step2Form.businessOwnership2;
						}

						console.log('postData', postData);

						api.postForm('/mobile/item/loanItemFrontApply/mgxyUpdateApplyForPersonDetails.ht', postData).then((res) => {
							console.log(res);
							var _data = res.data;
							this.isLoading = false;
							if (_data.code == 0) {
								this.$router.push({
									path: `/personalCenter/myLoan/loanLists?frontApplyState=0&pageCount=1`,
									query: {
										frontApplyState: 0,
										pageCount: 1
									}
								})
							} else {
								this.setAlertMessage({
									show: true,
									content: _data.msg
								})
							}
						});

					} else {
						return false;
					}
				})
			},

			getSMSVerificationCode() {
				this.isLoadingCode = true
				//alert(321)
				// REGISTRATIONä¸Žå¿˜è®°å¯†ç �çš„çŸ­ä¿¡éªŒè¯�å€’è®¡æ—¶ä¸�éœ€è¦�å…±ç”¨ï¼Œéœ€è¦�å°±å°†ç›¸å…³æ“�ä½œæ‰”åŽ»actionï¼ŒçŽ°åœ¨è¿™æ ·å°±ç›´æŽ¥è¯·æ±‚ï¼Œé™�ä½Žå¤�æ�‚åº¦
				// debugger;
				api.getSMSVerificationCodeForEmail({
					email: this.step2Form.email,
					tokenId: this.userInfo.token
				}).then((res) => {
					this.isAllowSendingVerifyCode = false
					const resData = res.data
					let countDownTime = 180
					if (Number(resData.code) === 0) {
						this.countDown = setInterval(() => {
							this.isLoadingCode = false
							this.isCounting = true
							countDownTime -= 1
							if (countDownTime !== 0) {
								this.SMSVerificationCodeBtn = {
									disabled: true,
									text: `After ${countDownTime} seconds`
								}
							} else {
								this.SMSVerificationCodeBtn = {
									disabled: false,
									text: 'get code'
								}
								clearInterval(this.countDown)
								this.isCounting = false
							}
						}, 1000)
					} else {
						this.isLoadingCode = false
						this.setAlertMessage({
							show: true,
							content: resData.result
						})
					}
				}).catch((error) => {
					if (error) {
						this.isLoadingCode = false
					} else {
						this.isLoadingCode = false
					}
				})
			}
		},
		//    beforeRouteLeave (to, from, next) {
		//      if (to.fullPath.indexOf('step1') !== -1) {
		//        this.goBack(next)
		//      } else if (to.fullPath.indexOf('step3') !== -1) {
		//        this.submitForm(next)
		//      }
		//    },
		mounted() {
			    document.title = "Personal Info - American Credit";
			this.getMgxyDictionary();
//			 this.$root.active='active'; try let sidebarmenu hide
		}
	}
</script>



<style lang="scss">
	.el-input.is-disabled .el-input__inner {
		background: #f7f7f7;
	}

	.step1-form .step-form__title {
		padding-bottom: 120px;
	}

	.second_main {
		margin-top: 10px;
	}

	.second_title {
		padding: 3px 0px 15px 0px;
		color: #747474;
	}

	.second_main .el-form-item__label {
		text-align: center;
	}

	.second_main input {
		margin-left: 0;
	}

	.second_main .label_text .el-form-item__label {
		width: 14% !important;
	}

	.second_main .label_text .el-form-item__content {
		margin-left: 15% !important;
	}

	.select_width .el-input__icon+.el-input__inner {
		padding-right: 95px;
	}

	.Infosave {
		margin: 15px 0px;
	}
</style>



// WEBPACK FOOTER //
// PersonInfo.vue?ae743182